var map = {
	"./aok.svg": "./src/assets/aok.svg",
	"./aok_favicon.ico": "./src/assets/aok_favicon.ico",
	"./aok_mobile.svg": "./src/assets/aok_mobile.svg",
	"./fr_favicon.ico": "./src/assets/fr_favicon.ico",
	"./logoFraunhoferWhite.png": "./src/assets/logoFraunhoferWhite.png",
	"./logoOrbis.png": "./src/assets/logoOrbis.png",
	"./orbis-logo.png": "./src/assets/orbis-logo.png",
	"./orbis_favicon.ico": "./src/assets/orbis_favicon.ico"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";